<template>
  <div class="app-product-page">
    <app-nav-page-view :tabHoverPage="1"></app-nav-page-view>
    <div class="app-product-banner">
      <app-banner-view
        :titleImageBackground="appProductBannerImage"
        :titleObj="productBannerObj"
      ></app-banner-view>
    </div>
    <app-title-page-view
      :titleObj="CustomerVoiceTitleObj"
    ></app-title-page-view>
    <div class="customer-voice">
      <div>
        “斗票网”是全国首家真正电影比价购票平台，与猫眼网，淘票票、
        网票网、卖座网等电影票务平台实时数据对接，覆盖全国10000家以上影院，
        是目前首家真正实现在线比价、购票、观影全流程业务的平台，且产品支持全面定制化开发。
        <br>
        “约车吧”是一款聚合打车平台，实现多平台一键叫车、在线比价等功能，
        目前已与首约汽车、滴滴出行、享道出行等国内一线出行平台合作，覆盖全国80%城市，
        旨在为用户提供最佳出行方式、最具性价比的打车方式。
      </div>
      <img class="customer-voice-image" :src="customerVoiceImage" alt="">
    </div>
    <app-title-page-view
      :titleObj="PartCaseTitleObj"
    ></app-title-page-view>
    <div class="app-part-of-the-case-banner">
      <app-product-page
        :bannerList="bannerList"
      >
      </app-product-page>
    </div>
    <div class="product-footer">
      <app-footer-page></app-footer-page>
    </div>
  </div>
</template>
<script>
//  import AppProductPage from '@/components/app/product/AppPartCaseSwiper.vue'
  import AppProductPage from '@/components/app/product/AppPartCaseView.vue'
  export default {
    name:'',
    data(){
      return {
        bannerSlidesPerView:3,
        bannerSlidesPerColumn:2,
        appProductBannerImage: require('./image/app-product-banner-image.png'),
        customerVoiceImage: require('./image/customer-voice-image.png'),
        productBannerObj:{
          mainHeading:'产品信息',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        CustomerVoiceTitleObj:{
          mainHeading:'Customer voice',
          subhead:'产品中心',
          content:''
        },
        PartCaseTitleObj:{
          mainHeading:'Part of the case',
          subhead:'部分案例',
          content:'“按需求定制最优框架，提供简单易用操作体验，交付满意服务成果”'
        }
      }
    },
    components:{
      'app-product-page':AppProductPage
    },
    computed:{
      bannerList(){
        return [
          {imgUrl:require('./image/icbc.png'), content:'中国工商银行- 影票系统'},
          {imgUrl:require('./image/zgyh.png'), content:'中国银行- 影票系统'},
          {imgUrl:require('./image/abc.png'), content:'中国农业银行- 影票系统'},
          {imgUrl:require('./image/abc-js.png'), content:'(江苏分行)- 影票系统'},
          {imgUrl:require('./image/jsyh.png'), content:'中国建设银行- 影票系统'},
          {imgUrl:require('./image/jtyh.png'), content:'交通银行- 影票系统'},
          {imgUrl:require('./image/bjyh.png'), content:'北京银行- 影票系统'},
          {imgUrl:require('./image/gdyh.png'), content:'光大银行- 影票系统'},
          {imgUrl:require('./image/gfyh.png'), content:'广发银行- 影票系统'},
          {imgUrl:require('./image/hxyh.png'), content:'华夏银行- 影票系统'},
          {imgUrl:require('./image/mdb.png'), content:'买单吧- 影票系统'},
          {imgUrl:require('./image/msyh.png'), content:'中国民生银行- 影票系统'},
          {imgUrl:require('./image/payh.png'), content:'平安银行- 影票系统'},
          {imgUrl:require('./image/pfyh.png'), content:'浦发银行- 影票系统'},
          {imgUrl:require('./image/shyh.png'), content:'上海银行- 影票系统'},
          {imgUrl:require('./image/xyyh.png'), content:'兴业银行- 影票系统'}
        ]
      }
    },
    methods:{
      actionClickBanner(index){
        console.log(index);
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-product-page{
    .app-product-banner{
      width:100%;
    }
    .customer-voice{
      width:100%;
      background:$color-4;
      padding:0.2rem 0 0.3rem 0;
      div{
        width:6.9rem;
        height:3.3rem;
        background:url('./image/customer-voice-title.png');
        background-size:100% 100%;
        margin:auto;
        padding:0.3rem;
        font-size:0.24rem;
        color:#555555;
        text-align: justify;
      }
      .customer-voice-image{
        width:2.6rem;
        height:2.6rem;
        margin-top:0.2rem;
      }
    }
    .app-part-of-the-case-banner{
      margin:auto;
      padding:0.3rem;
      background:$color-4;
    }
    .product-footer{
      margin-top:0.3rem;
    }
  }
</style>
